import { useEffect } from 'react';
import Lenis from 'lenis';
import { usePrefersReducedMotion } from './usePrefersReducedMotion';

export const useLenis = () => {
  const reducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    // Smooth scrolling is the one effect that cannot be toned down — hijacking
    // the scroll is exactly what motion-sensitive visitors ask us not to do —
    // so we hand scrolling back to the browser entirely.
    if (reducedMotion) return undefined;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      smooth: true,
      smoothTouch: false,
      touchMultiplier: 2,
    });

    // Store lenis instance globally for scroll reset
    if (typeof window !== 'undefined') {
      window.__lenis = lenis;
    }

    let frameId = requestAnimationFrame(function raf(time) {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    });

    return () => {
      cancelAnimationFrame(frameId);
      if (typeof window !== 'undefined' && window.__lenis === lenis) {
        delete window.__lenis;
      }
      lenis.destroy();
    };
  }, [reducedMotion]);
};
